<main>
    <div class="mt-4">
        <app-carousel-home [lists]="carouselHomeScreen" 
        [bannertext]="carouselHomeText?.bannerHoardingText"
        [bannerDesc]="carouselHomeText?.bannerHoardingDesc"
        >
        </app-carousel-home>
    </div>
    <div class="container pb-3">
        <section class="row journey" aria-labelledby="journey">
            <div class="col-sm-12 col-md-6">
                <h2 id="journey" class="mb-4 mb-md-0 journey--title">{{carouselHomeText?.journeyText?.ourServiceTitle}}</h2>
                
            </div>
            <div class="col-sm-12 col-md-6" [innerHtml]="carouselHomeText?.journeyText?.ourService">
                <!-- <p>{{carouselHomeText?.journeyText?.ourService}}</p> -->
            </div>
        </section>

        <app-download-app></app-download-app>
        <!-- <app-astrology-card [exploreAstro]="'required'"></app-astrology-card>

        <section class="row astro-profile">
            <div class="col-12">
                <h2>Our Astrologers</h2>
            </div>

            <div class="col-12">
                <app-carousel-card [astrologylists]="homePagePujaList"></app-carousel-card>
            </div>
        </section> -->
    </div>

    <div class="container-fluid mt-5 pt-md-5" *ngIf="homePagePuja" >
        <section class="row pujas align-items-center position-relative" aria-labelledby="pujas">
            <div class="col-sm-12 col-md-6 p-0">
                <img [src]="carouselHomeText.journeyText?.joinInPrayerImage || 'https://images.pexels.com/photos/3936815/pexels-photo-3936815.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260'"
                onerror="this.onerror=null;this.src='https://images.pexels.com/photos/3936815/pexels-photo-3936815.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260'"
                alt="..." class="pujas--container position-relative">
            </div>

            <div class="col-sm-12 col-md-6 pujas--info mt-3 mt-md-0 text-center text-md-left">
                <h2 id="pujas" class="h2">{{homePagePuja?.mainTitle}}</h2>
                <p>{{homePagePuja?.contentDescription}}</p>
                <button (click)="gotoExplore();" type="button"
                    class="btn btn-primary orange-stroked bold text-uppercase">{{ "BOTTONTEXT.EXPLORE" | translate }}</button>
            </div>

            <section class="container mt-4" aria-labelledby="mostPopular">
                <div class="col-12 p-0 text-center text-md-left">
                    <h3 id="mostPopular" class="h3">{{ "SITETEXT.MOSTPOPULAR" | translate }}</h3>
                    <!-- <div class="col">
                    </div> -->

                    <!-- <div class="col-auto"> -->
                        <!-- <button type="button" class="btn btn-primary orange-clear bold text-uppercase">see all <span
                                class="ic-">arrow_right</span></button> -->
                    <!-- </div> -->
                </div>
                <div class="col-12 carousel-tiles px-0 px-md-2">
                    <app-carousel-card [lists]="homePagePujaList"></app-carousel-card>
                </div>
            </section>
        </section>
    </div>
    <div class="container-fluid fly-above p-0"
    [style.backgroundImage]="'url('+ carouselHomeText?.journeyText?.ropewayImage +')'" >
        <div class="filter">
            <section class="container" aria-labelledby="fly">
                <h2 id="fly" class="h2 mb-4">{{carouselHomeText?.journeyText?.title}}</h2>
                <div class="w-100 text-center text-md-left">
                    <!-- <div class="col-auto px-2">
                        <button class="btn btn-primary white bold text-uppercase">udan khatola</button>
                    </div> -->
                    <div class="col-auto px-2">
                        <button class="btn btn-primary white-stroked bold text-uppercase" routerLink="ropeways" >{{ "SITETEXT.OURROPEWAY" | translate }}</button>
                    </div>
                </div>
            </section>
        </div>
    </div>

    <div class="container">
        <section class="row shaktipeethTV pb-3" aria-labelledby="shaktipeethTV">
            <div class="col-12 d-flex justify-content-between align-items-center">
                <div class="col-auto">
                    <h2 id="shaktipeethTV" class="h4">{{ "SITETEXT.SHAKTIPEETHTV" | translate }}</h2>
                </div>
                <div class="col-auto">
                    <button type="button" routerLink="gallery" class="btn btn-primary orange-clear bold text-uppercase d-flex align-items-center">
                        {{ "SITETEXT.SEEALL" | translate }} <span class="ic-">arrow_right</span>
                    </button>
                </div>
            </div>

            <div class="col-12 carousel-tiles">
                <app-carousel-card [shekTvlists]="homePageShaktipeethTVList"></app-carousel-card>
            </div>
        </section>

        <section class="row shaktipeethTV pt-0" aria-labelledby="shaktipeethTV">
            <div class="col-12 d-flex justify-content-between align-items-center">
                <div class="col-auto">
                    <h2 id="tistimi" class="h4">{{ "SITETEXT.TEXTTESTIMONIALS" | translate }}</h2>
                </div>
                <div class="col-auto">
                    <a type="button" href="testimonial" class="btn btn-primary orange-clear bold text-uppercase d-flex align-items-center">
                        {{ "SITETEXT.SEEALL" | translate }} <span class="ic-">arrow_right</span>
                    </a>
                </div>
            </div>

            <div class="col-12 carousel-tiles">
                <app-carousel-card [shekTvlists]="homePageTestimonialList"></app-carousel-card>
            </div>
        </section>

        
    </div>
</main>

<app-enquiryhomesidepanel></app-enquiryhomesidepanel>